module.exports = __webpack_public_path__ + "media/images/type-1-373dcfe0725694e8c5e215cc51942bfb.png";